import _isEmpty from 'lodash/isEmpty';
export function generateGoogleSearchQuery(place, address) {
  var _address$street = address.street,
    street = _address$street === void 0 ? '' : _address$street,
    _address$city = address.city,
    city = _address$city === void 0 ? '' : _address$city,
    _address$state = address.state,
    state = _address$state === void 0 ? '' : _address$state,
    _address$zip = address.zip,
    zip = _address$zip === void 0 ? '' : _address$zip;
  var locality = "".concat(city, ", ").concat(state, " ").concat(zip);
  var formattedAddress = street ? "".concat(street, ", ").concat(locality) : locality;
  return encodeURIComponent(!_isEmpty(place) ? "".concat(place, " ").concat(formattedAddress) : formattedAddress);
}
export function generateGoogleExternalUrl(place, address) {
  var query = generateGoogleSearchQuery(place, address);
  return "https://www.google.com/maps/place?q=".concat(query);
}